import Maximize16 from '@carbon/icons-react/es/maximize/16';
import Minimize16 from '@carbon/icons-react/es/minimize/16';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import {
  DistractionFreeMode,
  DocumentTabsFreeMode,
  selectDistractionFreeMode,
  selectDocumentTabsFreeMode,
  toggleDistractionFreeMode,
  toggleDocumentTabsFreeMode,
} from 'data/layout';
import { useToggleFreeMode } from 'hooks/use-toggle-free-mode';

interface Props {
  className?: string;
  isResponsive?: boolean;
}

const Shrink = styled(Minimize16)`
  transform: rotate(45deg);
`;
const Expand = styled(Maximize16)`
  transform: rotate(45deg);
`;

export const DistractionFreeModeBtn: FC<Props> = (props) => {
  const { isResponsive } = props;
  const dispatch = useDispatch();

  const onToggleDistractionFree = (value: boolean) => {
    dispatch(toggleDistractionFreeMode(value));
    dispatch(toggleDocumentTabsFreeMode(value));
  };
  const distractionFreeActive = useSelector(selectDistractionFreeMode);
  const { exit, enter } = useToggleFreeMode({
    active: distractionFreeActive,
    localStorageKey: DistractionFreeMode,
    onToggle: onToggleDistractionFree,
  });

  const onToggleDocumentTabs = (value: boolean) => {
    dispatch(toggleDistractionFreeMode(value));
    dispatch(toggleDocumentTabsFreeMode(value));
  };
  const documentsTabsActive = useSelector(selectDocumentTabsFreeMode);
  const { exit: documentExit, enter: documentEnter } = useToggleFreeMode({
    active: documentsTabsActive,
    localStorageKey: DocumentTabsFreeMode,
    onToggle: onToggleDocumentTabs,
  });

  const buttonClickHandler = () => {
    if (distractionFreeActive && documentsTabsActive) {
      exit();
      documentExit();
    } else {
      enter();
      documentEnter();
    }
  };

  if (isResponsive) {
    enter();
    documentEnter();
  }

  if (isResponsive) {
    return null;
  }

  return (
    <div {...props}>
      <Button
        size="small"
        icon={
          distractionFreeActive && documentsTabsActive ? <Shrink /> : <Expand />
        }
        onClick={buttonClickHandler}
      />
    </div>
  );
};

export const DistractionFreeModeBtnStyled = styled(DistractionFreeModeBtn)`
  position: absolute;
  right: 7%;
  top: 60px;
  z-index: var(--zindex-elevated);
  background: var(--white-color);
`;
